import { render, staticRenderFns } from "./fgjl.vue?vue&type=template&id=9cdbf5ce&scoped=true&"
import script from "./fgjl.vue?vue&type=script&lang=js&"
export * from "./fgjl.vue?vue&type=script&lang=js&"
import style0 from "./fgjl.vue?vue&type=style&index=0&id=9cdbf5ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cdbf5ce",
  null
  
)

export default component.exports